import "./PreOwnedExcellence.module.css";
import MainNavigation from "@/reusable_sections/Header";
import InventoryShowcase from "./sections/InventoryShowcase";
import OurInspectionProcess from "./sections/OurInspectionProcess";
import TradeInValuation from "./sections/TradeInValuation";
import GlobalFooter from "@/reusable_sections/Footer";
export default function PreOwnedExcellencePage() {
  return <div>
      <MainNavigation />
      <InventoryShowcase />
      <OurInspectionProcess />
      <TradeInValuation />
      <GlobalFooter />
    </div>;
}